import _defineProperty from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ChoiceDataType } from 'yo-services/yolabs/services/poplarfrontend/enums_pb';
import * as Yup from 'yup';
import { addBusinessDays } from 'date-fns';
import { I_DO_NOT_KNOW_ID } from '@poplar/constants/intake';
import { Textarea } from '@yoweb/ui/components/form';
import { Grid } from '@yoweb/ui/components/Grid';
import { Text } from '@yoweb/ui/components/typography';
import { DatePicker } from '@yoweb/ui/components/DatePicker';
import { compareChoiceValues, getChoiceValue, getFormattedChoiceValue } from './utils';
import AddressFormElements from '@poplar/components/AddressFormElements';
import { validatePostalCode } from '@yoweb/utils/postalCode';
import Checkbox from './Checkbox';
import { DateTime, getBaseSchema as getDateTimeBaseSchema } from './DateTime';
import { STANDARD_FIELD_LIMIT } from '@poplar/constants/app';
import { useTranslation } from '@yoweb/next-i18next';
import { useIntlMeta } from '@yoweb/ui/hooks/useIntlMeta';
import { useUser } from '@poplar/hooks/useUser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var MultipleChoiceWrapper = function MultipleChoiceWrapper(_ref) {
  var _values$questionId, _multipleChoicesAnswe;

  var id = _ref.id,
      multipleChoicesAnswer = _ref.multipleChoicesAnswer,
      instructionHint = _ref.instructionHint,
      isDisabled = _ref.isDisabled,
      _ref$formikProps = _ref.formikProps,
      values = _ref$formikProps.values,
      setFieldValue = _ref$formikProps.setFieldValue,
      children = _ref.children;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var _useIntlMeta = useIntlMeta(),
      locale = _useIntlMeta.locale,
      country = _useIntlMeta.country;

  var _useUser = useUser(),
      timeZone = _useUser.timeZone;

  var _id$split = id.split('.'),
      _id$split2 = _slicedToArray(_id$split, 2),
      questionId = _id$split2[0],
      index = _id$split2[1];

  if (!multipleChoicesAnswer) {
    return null;
  }

  var type = multipleChoicesAnswer.choiceDataType;

  var _ref2 = values === null || values === void 0 ? void 0 : (_values$questionId = values[questionId]) === null || _values$questionId === void 0 ? void 0 : _values$questionId[index],
      selected = _ref2.selected,
      showOther = _ref2.showOther;

  return /*#__PURE__*/_jsxs(Grid, {
    rowGap: "small3",
    children: [instructionHint && /*#__PURE__*/_jsx(Text, {
      size: "md",
      children: instructionHint
    }), (_multipleChoicesAnswe = multipleChoicesAnswer.choicesList) === null || _multipleChoicesAnswe === void 0 ? void 0 : _multipleChoicesAnswe.map(function (choice, choiceIndex) {
      var compareSelectedWithChoice = function compareSelectedWithChoice(selectedValue) {
        var _getChoiceValue;

        return compareChoiceValues(selectedValue, (_getChoiceValue = getChoiceValue(choice, type, country)) !== null && _getChoiceValue !== void 0 ? _getChoiceValue : '', type);
      };

      return /*#__PURE__*/_jsx(Checkbox // eslint-disable-next-line react/no-array-index-key
      , {
        id: "".concat(id, ".").concat(choiceIndex),
        name: "".concat(id, ".selected"),
        disabled: isDisabled,
        checked: selected.some(compareSelectedWithChoice),
        onChange: function onChange(e) {
          var isChecked = e.target.checked;

          if (isChecked) {
            setFieldValue("".concat(id, ".selected"), [].concat(_toConsumableArray(selected), [getChoiceValue(choice, type, country)]));
          } else {
            setFieldValue("".concat(id, ".selected"), selected === null || selected === void 0 ? void 0 : selected.filter(function (selectedValue) {
              return !compareSelectedWithChoice(selectedValue);
            }));
          }
        },
        children: getFormattedChoiceValue(choice, type, locale, timeZone)
      }, "".concat(id, ".").concat(choiceIndex));
    }), multipleChoicesAnswer.displayOtherField && /*#__PURE__*/_jsxs(Grid, {
      rowGap: "normal2",
      children: [/*#__PURE__*/_jsx(Checkbox, {
        id: "".concat(id, ".showOther"),
        name: "".concat(id, ".showOther"),
        disabled: isDisabled,
        children: t('todo-intake.other', {
          ns: 'common'
        })
      }), showOther && children]
    })]
  });
};

var getInitialValuesByType = function getInitialValuesByType(multipleChoiceAnswer, country) {
  var _otherValue$;

  var type = multipleChoiceAnswer.choiceDataType;
  var emptyInitialOther = getChoiceValue(undefined, type, country);
  var preFilledOther = multipleChoiceAnswer.otherNoteFromMemberProfile;

  if (multipleChoiceAnswer.answeredValuesList.length === 0) {
    var preSelectedValues = multipleChoiceAnswer.choicesList.filter(function (choice) {
      return choice.preselected;
    }).map(function (choice) {
      return getChoiceValue(choice, type, country);
    });
    return {
      selected: preSelectedValues,
      showOther: Boolean(preFilledOther),
      other: preFilledOther || emptyInitialOther
    };
  } // No way to tell if saved answer is 'other' or from choices


  var answeredValues = multipleChoiceAnswer.answeredValuesList.map(function (choice) {
    return getChoiceValue(choice, type, country);
  });
  var choicesValues = multipleChoiceAnswer.choicesList.map(function (choice) {
    return getChoiceValue(choice, type, country);
  }); // Check which values are not in choices

  var otherValue = answeredValues.filter(function (answeredValue) {
    return !choicesValues.some(function (choiceValue) {
      return compareChoiceValues(answeredValue, choiceValue, type);
    });
  });
  var selectedValues = answeredValues;

  if (otherValue.length > 1) {
    throw new Error("Multiple choice question has more than one other value: ".concat(otherValue));
  } else if (otherValue.length === 1) {
    // Remove other value from selected values
    selectedValues = selectedValues.filter(function (val) {
      return !compareChoiceValues(val, otherValue[0], type);
    });
  }

  return {
    selected: selectedValues,
    showOther: Boolean(otherValue.length),
    other: (_otherValue$ = otherValue[0]) !== null && _otherValue$ !== void 0 ? _otherValue$ : preFilledOther || getChoiceValue(undefined, type, country)
  };
};

export var getMultipleChoiceInitialValues = function getMultipleChoiceInitialValues(multipleChoiceAnswer, country) {
  return multipleChoiceAnswer ? getInitialValuesByType(multipleChoiceAnswer, country) : undefined;
};
export var getMultipleChoiceValidationSchema = function getMultipleChoiceValidationSchema(multipleChoiceAnswer, _isOptional, country, t) {
  var multiChoiceValidationSchema = Yup.object().when(I_DO_NOT_KNOW_ID, {
    is: true,
    then: Yup.object().shape({
      selected: Yup.array().of(Yup.string()),
      showOther: Yup["boolean"](),
      other: Yup.string().notRequired()
    }),
    otherwise: Yup.object().shape({
      selected: Yup.array().when('showOther', {
        is: true,
        then: Yup.array().of(Yup.string()),
        otherwise: Yup.array().of(Yup.string()).min(1, t('validation.required', {
          ns: 'common'
        }))
      }),
      showOther: Yup["boolean"](),
      other: Yup.string().when('showOther', {
        is: true,
        then: Yup.string().required(t('validation.required', {
          ns: 'common'
        })),
        otherwise: Yup.string().notRequired()
      })
    })
  });

  switch (multipleChoiceAnswer === null || multipleChoiceAnswer === void 0 ? void 0 : multipleChoiceAnswer.choiceDataType) {
    case ChoiceDataType.CHOICE_DATA_TYPE_LOCALIZED_TEXT:
    case ChoiceDataType.CHOICE_DATA_TYPE_STRING:
    case ChoiceDataType.CHOICE_DATA_TYPE_DATE:
      return multiChoiceValidationSchema;

    case ChoiceDataType.CHOICE_DATA_TYPE_DATE_TIME:
      {
        var baseSchema = getDateTimeBaseSchema(t, false);
        var baseSchemaRequired = getDateTimeBaseSchema(t, true);
        return Yup.object().when(I_DO_NOT_KNOW_ID, {
          is: true,
          then: Yup.object().shape({
            selected: Yup.array().of(baseSchema),
            showOther: Yup["boolean"](),
            other: baseSchema
          }),
          otherwise: Yup.object().shape({
            selected: Yup.array().when('showOther', {
              is: true,
              then: Yup.array().of(baseSchemaRequired),
              otherwise: Yup.array().of(baseSchemaRequired).min(1, t('validation.required', {
                ns: 'common'
              }))
            }),
            showOther: Yup["boolean"](),
            other: Yup.object().when('showOther', {
              is: true,
              then: baseSchemaRequired,
              otherwise: baseSchema
            })
          })
        });
      }

    case ChoiceDataType.CHOICE_DATA_TYPE_POSTAL_ADDRESS:
      {
        var addressSchema = Yup.object().shape({
          street1: Yup.string().trim().required(t('validation.required')),
          street2: Yup.string().trim().ensure(),
          city: Yup.string().trim().required(t('validation.required')),
          region: Yup.string().trim().required(t('validation.required')),
          postalCode: Yup.string().trim().required(t('validation.required')).test({
            message: t('validation.zip-code'),
            test: function test(value) {
              return value ? validatePostalCode(country, value) : false;
            }
          }),
          country: Yup.string().trim().required(t('validation.required'))
        });
        return Yup.object().when(I_DO_NOT_KNOW_ID, {
          is: true,
          then: Yup.object().shape({
            selected: Yup.array().of(addressSchema),
            showOther: Yup["boolean"](),
            other: Yup.object().notRequired()
          }),
          otherwise: Yup.object().shape({
            selected: Yup.array().when('showOther', {
              is: true,
              then: Yup.array().of(addressSchema),
              otherwise: Yup.array().of(addressSchema).min(1, t('validation.required', {
                ns: 'common'
              }))
            }),
            showOther: Yup["boolean"](),
            other: Yup.object().when('showOther', {
              is: true,
              then: addressSchema,
              otherwise: Yup.object()
            })
          })
        });
      }

    default:
      {
        throw new Error("Invalid choice data type: ".concat(multipleChoiceAnswer === null || multipleChoiceAnswer === void 0 ? void 0 : multipleChoiceAnswer.choiceDataType));
      }
  }
};
export var MultipleChoiceElement = function MultipleChoiceElement(props) {
  var _values$questionId2, _multipleChoicesAnswe2, _multipleChoicesAnswe3, _multipleChoicesAnswe4;

  var id = props.id,
      multipleChoicesAnswer = props.multipleChoicesAnswer,
      isDisabled = props.isDisabled,
      _props$formikProps = props.formikProps,
      values = _props$formikProps.values,
      setFieldValue = _props$formikProps.setFieldValue;

  var _id$split3 = id.split('.'),
      _id$split4 = _slicedToArray(_id$split3, 2),
      questionId = _id$split4[0],
      index = _id$split4[1];

  var _ref3 = values === null || values === void 0 ? void 0 : (_values$questionId2 = values[questionId]) === null || _values$questionId2 === void 0 ? void 0 : _values$questionId2[index],
      selected = _ref3.selected,
      other = _ref3.other,
      showOther = _ref3.showOther;

  switch (multipleChoicesAnswer === null || multipleChoicesAnswer === void 0 ? void 0 : multipleChoicesAnswer.choiceDataType) {
    case ChoiceDataType.CHOICE_DATA_TYPE_LOCALIZED_TEXT:
    case ChoiceDataType.CHOICE_DATA_TYPE_STRING:
      return /*#__PURE__*/_jsx(MultipleChoiceWrapper, _objectSpread(_objectSpread({}, props), {}, {
        children: /*#__PURE__*/_jsx(Textarea, {
          id: "".concat(id, ".otherInput"),
          name: "".concat(id, ".other"),
          type: "text",
          label: (_multipleChoicesAnswe2 = multipleChoicesAnswer.otherFieldHint) !== null && _multipleChoicesAnswe2 !== void 0 ? _multipleChoicesAnswe2 : '',
          disabled: isDisabled,
          maxLength: (_multipleChoicesAnswe3 = (_multipleChoicesAnswe4 = multipleChoicesAnswer.otherNoteMaxLength) === null || _multipleChoicesAnswe4 === void 0 ? void 0 : _multipleChoicesAnswe4.value) !== null && _multipleChoicesAnswe3 !== void 0 ? _multipleChoicesAnswe3 : STANDARD_FIELD_LIMIT,
          rows: 1
        })
      }));

    case ChoiceDataType.CHOICE_DATA_TYPE_DATE:
      return /*#__PURE__*/_jsx(MultipleChoiceWrapper, _objectSpread(_objectSpread({}, props), {}, {
        children: /*#__PURE__*/_jsx(DatePicker, {
          label: multipleChoicesAnswer.otherFieldHint || '--',
          id: "".concat(id, ".otherInputDate"),
          name: "".concat(id),
          disabled: isDisabled,
          minDate: addBusinessDays(new Date(), 3),
          selected: other ? new Date(Number(other) * 1000) : undefined,
          onChange: function onChange(date) {
            if (date) {
              setFieldValue(id, {
                selected: selected,
                showOther: showOther,
                other: String(date.getTime() / 1000)
              });
            }
          }
        })
      }));

    case ChoiceDataType.CHOICE_DATA_TYPE_DATE_TIME:
      return /*#__PURE__*/_jsx(MultipleChoiceWrapper, _objectSpread(_objectSpread({}, props), {}, {
        children: /*#__PURE__*/_jsx(DateTime, {
          id: id,
          values: other,
          setValues: function setValues(value) {
            return setFieldValue("".concat(id, ".other"), value);
          },
          inputFieldHint: multipleChoicesAnswer.otherFieldHint,
          inputFieldHintTime: multipleChoicesAnswer === null || multipleChoicesAnswer === void 0 ? void 0 : multipleChoicesAnswer.otherFieldHintTime,
          minDate: addBusinessDays(new Date(), 3),
          isDisabled: isDisabled
        })
      }));

    case ChoiceDataType.CHOICE_DATA_TYPE_POSTAL_ADDRESS:
      {
        var setNestedValues = function setNestedValues(nestedValues) {
          return setFieldValue(id, {
            selected: selected,
            showOther: showOther,
            other: nestedValues
          });
        };

        return /*#__PURE__*/_jsx(MultipleChoiceWrapper, _objectSpread(_objectSpread({}, props), {}, {
          children: /*#__PURE__*/_jsx(AddressFormElements, {
            fieldNamePrefix: "".concat(id, ".other."),
            values: other,
            setValues: setNestedValues
          })
        }));
      }

    default:
      return null;
  }
};